
<template>
	<v-container fluid="fluid" class="text-xs-center mpa-0 pa-4">
		<v-layout row wrap>
			<users-table
				@showUser="showUser"
				ref="usersTables"
				:filters="filters"
			></users-table>
			<v-btn fixed dark fab bottom right color="pink" @click="newUser">
				<v-icon>add</v-icon>
			</v-btn>
		</v-layout>
		<user-modal
			:id="user.id"
			:edit="edit"
			:user="user"
			@showHistory="showHistory"
			@userUpdated="$refs.usersTables.getUsers()"
			:showSelector="false"
		></user-modal>
		<history-modal
			:id="reservation.id"
			:edit="historyEdit"
			:selectedReservation="reservation"
		></history-modal>
	</v-container>
</template>
<script>
import UsersTable from '@/components/Users/UsersTable';
import HistoryModal from '@/components/History/HistoryModal';
import UserModal from '@/components/Users/UserModal';
export default {
	name: 'Users',
	components: { UsersTable, UserModal, HistoryModal },
	data() {
		return {
			user: {
				edit: false
			},
			src: '',
			edit: {
				showModal: false
			},
			historyEdit: {
				showModal: false
			},
			reservation: {},
			editReservation: {},
			units: [],
			filters: {}
		};
	},
	mounted() {
		if (this.$route.params.userid) {
			this.showUser({ id: this.$route.params.userid });
		}
	},
	methods: {
		showUser(user) {
			this.edit.showModal = true;
			user.edit = true;
			this.user = user;
		},
		newUser() {
			this.user = {
				id: -1,
				edit: true,
				paid: '1',
				active: '1',
				canRent: '1',
				credit: 0
			};
			this.edit.showModal = true;
		},
		showHistory(reservation) {
			this.historyEdit.showModal = true;
			this.reservation = reservation;
		}
	}
};
</script>

<style scoped>
h1,
h2 {
	font-weight: normal;
}
ul {
	list-style-type: none;
	padding: 0;
}
li {
	display: inline-block;
	margin: 0 10px;
}
a {
	color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Users.vue